import React from 'react';
import './EntryShowItemDetail.css';
import { getCloudinaryUrl } from '../../cloudinaryConfig'; 
import { Link } from 'react-router-dom';
import { Popup } from 'semantic-ui-react';
import ReactMarkdown from 'react-markdown';

const EntryShowItemDetail = (props) => {

    const includedoutlinerefs = props.outlinerefs.filter((reference) =>{
        return Number(reference) < Number(446) || (Number(792) < Number(reference) && Number(reference) < Number(851)) || Number(894) < Number(reference) 
    });

    let outlinerefs = includedoutlinerefs.map((ref, i) => {
        return <span key={i} className="outlinerefs">
            <Link key={i} target="_blank" to={`/entries/${ref}`}>
                <Popup trigger={<span>{ (i ? ', ' : '') + ref }</span>} position="bottom center">
                    <img className="popupimage" src={getCloudinaryUrl(ref, "popup")} alt={ref}/>
                </Popup>
            </Link>
        </span>
    });

    let details = props.detail.map((detail, j) => {
        const includedsubentryrefs = detail.subentryrefs.filter((reference) => {
            return Number(reference) < Number(446) || (Number(792) < Number(reference) && Number(reference) < Number(851)) || Number(894) < Number(reference) 
        });
        return(
            <div key={j} className="subentry">
                <div className="subentrymain"> <span className="subentryid"> {detail.subentryid}</span>{" "}<ReactMarkdown>{detail.content}</ReactMarkdown></div>
                <div className="subentryrefs">{includedsubentryrefs.map((ref, k) => {
                    return <span key={k}>
                        <Link key={k} target="_blank" to={`/entries/${ref}`}>
                            <Popup trigger={<span>{ (k ? ', ' : '') + ref }</span>} position="bottom center">
                                <img className="popupimage" src={getCloudinaryUrl(ref, "popup")} alt={ref}/>
                            </Popup>
                        </Link>
                    </span>
                })}
                </div>
            </div>
        );
    })

    let interval1 = Array.from(Array(445).keys(), n => n + 1);
    let interval2 = Array.from(Array(58).keys(), n => n + 793);
    let interval3 = Array.from(Array(108).keys(), n => n + 895);
    let availableentries = interval1.concat(interval2).concat(interval3);
    console.log(availableentries.indexOf(props.id));

    return (
        <div className="ui container grid">
            <div className="ui stackable two column grid">
                <div className="column sticky">
                    <div className="mymeta">
                        <i className="hashtag icon">{props.id}</i>{props.category}
                    </div>
                    <div className="ui image sticky">
                        <img src={getCloudinaryUrl(props.id, "full")} alt={props.id} />
                    </div>
                </div>
                <div className="column">
                    <div><ReactMarkdown>{props.outline}</ReactMarkdown></div>
                    <div>{outlinerefs}</div>
                    <hr></hr>
                    <div>{details}</div>
                    <div className='navigation link'>
                        <span>
                            <Link target="_self" to={`/entries/${availableentries[availableentries.indexOf(props.id) - 1]}`}>
                                {props.id === 1 ? '' : `Previous entry (${availableentries[availableentries.indexOf(props.id) - 1]})`}
                            </Link>
                            <Link target="_self" to={`/entries/${availableentries[availableentries.indexOf(props.id) + 1]}`}>
                                {props.id === 1002 ? '' : `\u00A0\u00A0\u00A0\u00A0\u00A0 Next entry (${availableentries[availableentries.indexOf(props.id) + 1]})`}
                            </Link>
                        </span>
                    </div>             
                </div>
            </div>
        </div>    
    );
}


export default EntryShowItemDetail;

